import './Marble.css';

export default function Marble({ Icon, c1, c2, size = 48 }) {
  const style = {
    '--c1': c1,
    '--c2': c2,
    width: size,
    height: size,
  };
  return (
    <span className="marble" style={style} aria-hidden="true">
      <span className="marble-base" />
      <span className="marble-highlight" />
      <span className="marble-shine" />
      <span className="marble-rim" />
      {Icon && <Icon className="marble-icon" sx={{ fontSize: size * 0.46 }} />}
    </span>
  );
}
